// Basket Amount Change Check

function checkBasketAmount(field, checkValue) {
    let form_id = field.form.id,
        field_id = field.id,
        field_value = field.dataset.value,
        field_error = document.querySelector('#' + field_id + ' ~ .field-error'),
        reload_button = document.querySelector('#' + form_id + ' .but--recount');

    if (field_value != checkValue) {
        showError(field, field_error, 'amountChangeNotSent');
        // reload_button.className = 'highlight';
        reload_button.style.display = 'block';
        reload_button.classList.add('highlight');
    } else {
        field_error.textContent = '';
        field_error.className = 'field-error';
        // reload_button.className = '';
        reload_button.style.display = 'none';
        reload_button.classList.remove('highlight');
    }
}

function setBasketAmountCheck() {
    const fields = document.getElementsByClassName('check-basket-amount-change');
    for (let i = 0; i < fields.length; ++i) {
        let field = fields[i],
            field_value = field.value;

        field.setAttribute('data-value', field_value);

        field.addEventListener('input', function() {
            checkBasketAmount(field, this.value);
        });
    }
}

setBasketAmountCheck();